import React from "react";
import InfoTable from "../../components/tables/InfoTable";
import CustomDialog from "../../components/layouts/common/CustomDialog";
import { useDispatch } from "react-redux";
import { closeModal } from "../../store/actions/modalAction";
import { InformationUI } from "../../components/InformationUI";
import { Box, Card, CircularProgress, Grid, Typography } from "@mui/material";
import { CenteredBox } from "../../components/layouts/OneViewBox";
import FileInput from "../../components/layouts/upload/FileInput";
import ImageComponent from "../../components/layouts/upload/ImageComponent";

const DataView = ({ TableData, TableTitle, tableKey, indexNo }) => {
  const isRawMaterials = tableKey === "rawMaterials";

  const getColumnSize = (column) => {
    if (isRawMaterials && indexNo) {
      return { sr: 2, name: 4, code: 3, qty: 3 }[column];
    }

    if (isRawMaterials) {
      return { name: 5, code: 3, qty: 4 }[column];
    }

    if (indexNo) {
      return { sr: 2, name: 5, qty: 5 }[column];
    }

    return { name: 6, qty: 6 }[column];
  };

  return (
    TableData &&
    TableTitle && (
      <Box p={2} sx={{ border: "1px solid rgba(0,0,0,0.2)", borderRadius: 2 }}>
        <Box p={2}>
          <Typography fontWeight="bold" variant="h6">
            {TableTitle}
          </Typography>
        </Box>

        {/* Header */}
        <Card sx={{ mb: 2, p: 2, backgroundColor: "rgba(0,0,0,0.08)" }}>
          <Grid container alignItems="center" spacing={3}>
            {indexNo && (
              <Grid item xs={getColumnSize("sr")} textAlign="center">
                <Typography fontWeight="bold">Sr No</Typography>
              </Grid>
            )}

            <Grid item xs={getColumnSize("name")} textAlign="center">
              <Typography fontWeight="bold">Name</Typography>
            </Grid>

            {isRawMaterials && (
              <Grid item xs={getColumnSize("code")} textAlign="center">
                <Typography fontWeight="bold">Code</Typography>
              </Grid>
            )}

            <Grid item xs={getColumnSize("qty")} textAlign="center">
              <Typography fontWeight="bold">
                Min Of Quantity Required
              </Typography>
            </Grid>
          </Grid>
        </Card>

        {/* Rows */}
        {TableData.map((item, index) => (
          <Card key={index} sx={{ mb: 2, p: 2 }}>
            <Grid container alignItems="center" spacing={3}>
              {indexNo && (
                <Grid item xs={getColumnSize("sr")} textAlign="center">
                  <Typography variant="body2">{index + 1}</Typography>
                </Grid>
              )}

              <Grid item xs={getColumnSize("name")} textAlign="center">
                <Typography variant="body2">{item?.name}</Typography>
              </Grid>

              {isRawMaterials && (
                <Grid item xs={getColumnSize("code")} textAlign="center">
                  <Typography variant="body2">{item?.code}</Typography>
                </Grid>
              )}

              <Grid item xs={getColumnSize("qty")} textAlign="center">
                <Typography variant="body2">{item?.min_of_quantity}</Typography>
              </Grid>
            </Grid>
          </Card>
        ))}
      </Box>
    )
  );
};

const FinishGoodInfoUi = ({ data, loading }) => {
  const dispatch = useDispatch();
  console.log("img", data?.product_image);
  return (
    <CustomDialog
      id={"infoupdatee"}
      title={"Finished Good"}
      closeText="Close"
      onClose={() => dispatch(closeModal("infoupdatee"))}
    >
      {loading ? (
        <CenteredBox>
          {" "}
          <CircularProgress />{" "}
        </CenteredBox>
      ) : (
        <>
          <InformationUI
            Data={[
              { label: "FG Name :", value: data?.name },
              { label: "FG Code :", value: data?.fg_Code || "NA" },
              { label: "FG Type :", value: data?.product_type?.name || "NA" },
              { label: "FG Color :", value: data?.product_color?.name || "NA" },
              { label: "FG Brand :", value: data?.product_brand?.name || "NA" },
              { label: "Price :", value: data?.product_price || "NA" },
              // { label: "Description :", value: data?.description || "NA" },
              {
                label: "Special Marking :",
                value: data?.specialMarking?.name || "NA",
              },
              {
                label: "Image :",
                value: data?.product_image ? (
                  <ImageComponent src={data?.product_image} />
                ) : (
                  "NA"
                ),
              },
            ]}
          />
          {data?.sfg?.length > 0 && (
            <Box mb={2}>
              <DataView
                TableTitle={"Semi Finished Good"}
                TableData={data?.sfg}
                tableKey="sfgs"
                indexNo={true}
              />
            </Box>
          )}
          {data?.skds?.length > 0 && (
            <Box mb={2}>
              <DataView
                indexNo={true}
                TableTitle={"Semi Knocked Down"}
                TableData={data?.skds}
                tableKey="skds"
              />
            </Box>
          )}
          {data?.rawMaterials?.length > 0 && (
            <Box mb={2}>
              <DataView
                indexNo={true}
                TableTitle={"Raw Materials"}
                TableData={data?.rawMaterials}
                tableKey="rawMaterials"
              />
            </Box>
          )}
        </>
      )}
    </CustomDialog>
  );
};

export default FinishGoodInfoUi;
